// extracted by mini-css-extract-plugin
module.exports = {"input":"_-_-pharmacy-src-input-button-buttonCheckbox__input--2hVJ7"};